import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Header from '../components/Header';

const Login = () => {
    const { login } = useAuth();
    const [loginInput, setLoginInput] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);
        const result = await login(loginInput, password);
        if (result.success) {
            navigate('/');
        } else {
            setError(result.message);
        }
        setIsLoading(false);
    };

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-[#1c0042] p-6 relative overflow-x-hidden bg-gradient-to-b from-[#1c0042] to-[#0e0024]">
            <Header title="Admin Portal" subtitle=" Latitude Control" />

            <div className="bg-white/5 backdrop-blur-xl border border-white/10 p-10 rounded-[40px] shadow-2xl flex flex-col items-center w-full max-w-md relative z-10 animate-fadeIn">
                <div className="mb-8 text-center">
                    <p className="text-white/40 text-[10px] font-black uppercase tracking-[0.3em]">Gestiona con total control</p>
                </div>

                <form onSubmit={handleSubmit} className="w-full space-y-6">
                    <div>
                        <label className="block text-slate-200 text-sm font-medium mb-2 pl-1">Identificación o Correo</label>
                        <input
                            type="text"
                            className="w-full bg-slate-800/50 border border-white/10 p-4 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all placeholder:text-slate-500"
                            placeholder="Ej: 12345678 o admin@neuro.com"
                            value={loginInput}
                            onChange={(e) => setLoginInput(e.target.value)}
                            required
                        />
                    </div>
                    <div>
                        <label className="block text-slate-200 text-sm font-medium mb-2 pl-1">Contraseña</label>
                        <input
                            type="password"
                            className="w-full bg-slate-800/50 border border-white/10 p-4 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all placeholder:text-slate-500"
                            placeholder="••••••••"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>

                    {error && (
                        <div className="bg-red-500/20 border border-red-500/30 text-red-400 p-4 rounded-xl text-sm text-center">
                            {error}
                        </div>
                    )}

                    <button
                        type="submit"
                        disabled={isLoading}
                        className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-bold py-4 rounded-xl hover:from-blue-500 hover:to-indigo-500 transition-all transform hover:scale-[1.02] active:scale-95 shadow-xl shadow-blue-900/40 disabled:opacity-50"
                    >
                        {isLoading ? 'Cargando...' : 'Entrar Ahora'}
                    </button>

                    <div className="mt-6 text-center">
                        <span className="text-slate-400 text-xs uppercase tracking-widest font-semibold">Sistema de Seguridad </span>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Login;
